"use client";

import { BookOpen, Compass, Users } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Un processus exigeant",
  description: "Obtenir l’enregistrement d’une certification auprès de France Compétences est un processus complexe, exigeant et soumis à des critères stricts. Les dossiers incomplets, mal structurés ou insuffisamment argumentés sont systématiquement refusés ou ajournés.",
  icon: Compass
}, {
  title: "Expertise et Pragmatisme",
  description: "Effet Conseil maîtrise l’intégralité du processus : de l’étude de faisabilité initiale jusqu’au déploiement opérationnel de votre certification enregistrée. L’approche pragmatique et structurée permet de sécuriser chaque étape et d’optimiser vos chances de réussite, en traduisant les critères techniques de France Compétences en langage clair et en actions concrètes.",
  icon: Users
}, {
  title: "Levier stratégique",
  description: "L’engagement d’Effet Conseil : transformer votre projet de certification en un levier stratégique de crédibilité, de différenciation et de pérennité pour votre organisation, dans le respect des principes éthiques et de la responsabilité sociétale.",
  icon: BookOpen
}];
export default function InfoColumns() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="147882" id="strategiccertification" className="bg-background text-foreground ![padding:96px_0px_0px_0px]">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-6xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-3xl font-bold text-center mb-16 tracking-tight !text-[hsl(210,10%,23%)] md:text-4xl">Créer ou renouveler une certification RNCP/RS :<br />un enjeu stratégique qui exige expertise et rigueur</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="bg-card border-border text-card-foreground hover:-translate-y-2 hover:shadow-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] flex flex-col h-full rounded-[2px]">
                
                <CardContent className="flex-grow">
                  <p className="font-sans text-card-foreground/80 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}